import { render, staticRenderFns } from "./conversations.vue?vue&type=template&id=af937c22&scoped=true"
import script from "./conversations.vue?vue&type=script&lang=js"
export * from "./conversations.vue?vue&type=script&lang=js"
import style0 from "./conversations.vue?vue&type=style&index=0&id=af937c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af937c22",
  null
  
)

export default component.exports